var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMosque(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3626_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1625_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2194_",
    d: "m307 177h10v70h-10z",
    fill: "#ffb30f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1632_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2795_",
    d: "m190 69h10v50h-10z",
    fill: "#ffb30f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1637_",
    d: "m175 118.7h40v210h-40z",
    fill: "#399349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1638_",
    d: "m150 278.7h260v140h-260z",
    fill: "#399349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1773_",
    d: "m150 373.7h260v45h-260z",
    fill: "#2b6e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1635_",
    d: "m168 198.7h54v20h-54z",
    fill: "#ffb30f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1634_",
    d: "m168 118.7h54v20h-54z",
    fill: "#ffb30f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1633_",
    d: "m195 98.7c-11 0-20 9-20 20h40c0-11-9-20-20-20z",
    fill: "#ffcb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1631_",
    d: "m312.5 206.2c-40 0-72.5 32.5-72.5 72.5h145c0-40-32.5-72.5-72.5-72.5z",
    fill: "#ffcb5d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1630_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2180_",
    d: "m190 169h10v30h-10z",
    fill: "#ffcb5d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1629_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2175_",
    d: "m190 249h10v30h-10z",
    fill: "#ffcb5d"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffb30f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1628_",
    d: "m312.5 328.7c-13.8 0-25 11.2-25 25v65h50v-65c0-13.8-11.2-25-25-25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1627_",
    d: "m410 328.7c-13.8 0-25 11.2-25 25v65h25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1626_",
    d: "m215 328.7c-13.8 0-25 11.2-25 25v65h50v-65c0-13.8-11.2-25-25-25z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2526_",
    d: "m301 417.3c-113.8 0-206-92.2-206-206 0-106.5 81.3-193.6 185-204.3-7.8-.7-16.1-1.7-24-1.7-138.6 0-251 112.4-251 251s112.4 251 251 251 251-112.4 251-251c0-7.9-1.3-15.5-2-23.3-10.7 103.7-97.5 184.3-204 184.3z",
    fill: "#ffcb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1639_",
    d: "m507 256.3c0 138.6-112.4 251-251 251s-251-112.4-251-251 112.4-251 251-251c4 0 8 .3 12.1.6 0 0 0 .1-.1.3-121.2 5.3-218 105-218 227.6 0 126.2 102.3 228.5 228.5 228.5 122.6 0 222.1-96.5 227.5-217.6.2 0 .3-.1.3-.1.4 3.9.7 7.7.7 11.7z",
    fill: "#ffe3a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1624_",
    d: "m410 156.5 24.7 16.5-8-28.6 23.3-18.4-29.7-1.1-10.3-27.9-10.3 27.9-29.7 1.1 23.3 18.4-8 28.6z",
    fill: "#ffb30f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1623_",
    d: "m110 214.5 24.7 16.5-8-28.6 23.3-18.4-29.7-1.1-10.3-27.9-10.3 27.9-29.7 1.1 23.3 18.4-8 28.6z",
    fill: "#ffb30f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1636_",
    d: "m175 138.7h40v20h-40z",
    fill: "#2b6e38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2794_",
    d: "m175 218.7h40v20h-40z",
    fill: "#2b6e38"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3429_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1905_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3071_",
    d: "m256 512.3c-68.4 0-132.7-26.6-181-75-48.4-48.3-75-112.6-75-181s26.6-132.7 75-181 112.6-75 181-75c6.7 0 13.6.7 20.2 1.3 1.4.1 2.9.3 4.3.4 2.6.2 4.5 2.4 4.5 5s-1.9 4.7-4.5 5c-92.5 9.5-165.9 80.1-178.6 171.6l-9.9-1.4c6.4-46.2 28.6-89.6 62.5-122.2 23.3-22.4 51.6-39.2 82.2-49-126.7 9.9-226.7 116.1-226.7 245.3 0 135.6 110.4 246 246 246 129.1 0 235.3-100 245.2-226.5-27.1 85.9-106.9 146.5-200.2 146.5-50.5 0-99.4-18.1-137.6-51-37.8-32.6-63-77.5-70.8-126.5l9.9-1.6c15.6 98 99.1 169.1 198.5 169.1 102.9 0 188.4-77.3 199-179.8.3-2.5 2.4-4.5 5-4.5 2.6 0 4.7 2 5 4.5.2 2.3.5 4.6.7 6.9.6 5.4 1.3 11 1.3 16.8 0 68.4-26.6 132.7-75 181-48.3 48.5-112.6 75.1-181 75.1z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3070_",
    d: "m415 365.7h-10v-82h-250v67.4h-10v-72.4c0-2.8 2.2-5 5-5h260c2.8 0 5 2.2 5 5z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2765_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3067_",
    d: "m215 283.7h-40c-2.8 0-5-2.2-5-5v-60c0-2.8 2.2-5 5-5h40c2.8 0 5 2.2 5 5v60c0 2.8-2.2 5-5 5zm-35-10h30v-50h-30z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2764_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3064_",
    d: "m215 203.7h-40c-2.8 0-5-2.2-5-5v-60c0-2.8 2.2-5 5-5h40c2.8 0 5 2.2 5 5v60c0 2.8-2.2 5-5 5zm-35-10h30v-50h-30z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2763_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3061_",
    d: "m222 223.7h-54c-2.8 0-5-2.2-5-5v-20c0-2.8 2.2-5 5-5h54c2.8 0 5 2.2 5 5v20c0 2.8-2.2 5-5 5zm-49-10h44v-10h-44z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2762_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3058_",
    d: "m222 143.7h-54c-2.8 0-5-2.2-5-5v-20c0-2.8 2.2-5 5-5h54c2.8 0 5 2.2 5 5v20c0 2.8-2.2 5-5 5zm-49-10h44v-10h-44z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2760_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3055_",
    d: "m215 123.7h-40c-2.8 0-5-2.2-5-5 0-13.8 11.2-25 25-25s25 11.2 25 25c0 2.8-2.2 5-5 5zm-34.1-10h28.3c-2.1-5.8-7.6-10-14.1-10s-12.2 4.2-14.2 10z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2759_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3054_",
    d: "m190 69h10v30h-10z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2758_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3051_",
    d: "m385 283.7h-145c-2.8 0-5-2.2-5-5 0-42.7 34.8-77.5 77.5-77.5s77.5 34.8 77.5 77.5c0 2.8-2.2 5-5 5zm-139.8-10h134.6c-2.6-34.9-31.8-62.5-67.3-62.5s-64.8 27.6-67.3 62.5z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2757_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3050_",
    d: "m190 169h10v30h-10z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2756_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3049_",
    d: "m190 249h10v30h-10z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3048_",
    d: "m292.5 416.6h-10v-62.9c0-16.5 13.5-30 30-30s30 13.5 30 30v60.1h-10v-60.1c0-11-9-20-20-20s-20 9-20 20z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1900_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3047_",
    d: "m390 399.1h-10v-45.4c0-16.5 13.5-30 30-30v10c-11 0-20 9-20 20z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3046_",
    d: "m245 407.8h-10v-54.1c0-11-9-20-20-20s-20 9-20 20v30.9h-10v-30.9c0-16.5 13.5-30 30-30s30 13.5 30 30z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2752_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3045_",
    d: "m307 177h10v30h-10z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_530_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3042_",
    d: "m434.7 178c-1 0-1.9-.3-2.8-.8l-21.9-14.7-21.9 14.6c-1.7 1.2-4 1.1-5.7-.1s-2.4-3.4-1.9-5.4l7.1-25.4-20.7-16.2c-1.6-1.3-2.3-3.5-1.7-5.5s2.5-3.4 4.6-3.5l26.4-1 9.1-24.7c.7-2 2.6-3.3 4.7-3.3s4 1.3 4.7 3.3l9.1 24.7 26.4 1c2.1.1 3.9 1.5 4.6 3.5s0 4.2-1.7 5.5l-20.7 16.3 7.1 25.4c.6 2-.2 4.2-1.9 5.4-.8.6-1.8.9-2.9.9zm-24.7-26.5c1 0 1.9.3 2.8.8l13.5 9-4.4-15.6c-.5-1.9.1-4 1.7-5.3l12.7-10-16.2-.6c-2-.1-3.8-1.4-4.5-3.3l-5.6-15.2-5.6 15.2c-.7 1.9-2.5 3.2-4.5 3.3l-16.2.6 12.7 10c1.6 1.3 2.3 3.3 1.7 5.3l-4.4 15.6 13.5-9c.9-.5 1.8-.8 2.8-.8z",
    fill: "#4d2419"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_529_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3039_",
    d: "m134.7 236c-1 0-1.9-.3-2.8-.8l-21.9-14.7-21.9 14.6c-1.7 1.2-4 1.1-5.7-.1s-2.4-3.4-1.9-5.4l7.1-25.4-20.7-16.2c-1.6-1.3-2.3-3.5-1.7-5.5s2.5-3.4 4.6-3.5l26.4-1 9.1-24.7c.7-2 2.6-3.3 4.7-3.3s4 1.3 4.7 3.3l9.1 24.7 26.4 1c2.1.1 3.9 1.5 4.6 3.5s0 4.2-1.7 5.5l-20.7 16.3 7.1 25.4c.6 2-.2 4.2-1.9 5.4-.8.6-1.8.9-2.9.9zm-24.7-26.5c1 0 1.9.3 2.8.8l13.5 9-4.4-15.6c-.5-1.9.1-4 1.7-5.3l12.7-10-16.2-.6c-2-.1-3.8-1.4-4.5-3.3l-5.6-15.2-5.6 15.2c-.7 1.9-2.5 3.2-4.5 3.3l-16.2.6 12.7 10c1.6 1.3 2.3 3.3 1.7 5.3l-4.4 15.6 13.5-9c.9-.5 1.8-.8 2.8-.8z",
    fill: "#4d2419"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMosque);
export default __webpack_public_path__ + "static/media/mosque.01c7da0614362a850c34da4d894196e0.svg";
export { ForwardRef as ReactComponent };